import { gql } from 'graphql-request'

class OfferQueries {
  getAll = gql`
    query Offers($where: OfferWhereInput, $first: Int, $skip: Int, $orderBy: OfferExtendedOrderByInput) {
      offers(where: $where, first: $first, skip: $skip, orderBy: $orderBy) {
        id
        title
        customer {
          id
          name
        }
        places {
          id
          name
        }
        type
        createdAt
        earnableFrom
        earnableTo
        redeemableFrom
        redeemableTo
        categories {
          id
          name
        }
        image {
          url
        }
        termsAndConditions
        howToRedeem
        description
        cost
        maxClaimable
        nbPermittedClaims
        qrCode {
          url
        }
        activeMessage
        redemptionType
        onlineRedemptionUrl
        onlineRedemptionCode
      }
    }
  `
  getOne = gql`
    query Offer($where: OfferWhereUniqueInput!) {
      offer(where: $where) {
        id
        title
        customer {
          id
          name
        }
        places {
          id
          name
        }
        type
        createdAt
        earnableFrom
        earnableTo
        redeemableFrom
        redeemableTo
        categories {
          id
          name
        }
        image {
          url
          reference
        }
        termsAndConditions
        howToRedeem
        description
        cost
        maxClaimable
        nbPermittedClaims
        qrCode {
          url
          reference
        }
        activeMessage
        redemptionType
        onlineRedemptionUrl
        onlineRedemptionCode
      }
    }
  `
  getPaginatedAll = gql`
    query getPaginatedOffers($where: OfferWhereInput, $first: Int, $skip: Int, $orderBy: OfferExtendedOrderByInput) {
      offersConnection(where: $where, first: $first, skip: $skip, orderBy: $orderBy) {
        edges {
          node {
            id
            title
            description
            image {
              id
              url
            }
            customer {
              id
              name
            }
            places {
              name
            }
            type
            createdAt
            earnableFrom
            earnableTo
            redeemableFrom
            redeemableTo
          }
        }
      }
    }
  `
}

const offerQueries = new OfferQueries()

export default offerQueries
